import React, { useContext } from "react";
import NewsItem from "./SingleNewsItem";
import NewsContext from "../../context/News/NewsContext";
const NewsContainer = () => {
  const { specificNews, news } = useContext(NewsContext);
  return (
    <div className="NewsContainer">
      {specificNews && specificNews.length < 5
        ? news &&
          news.length > 0 &&
          [...specificNews, ...news].map((n, index) => (
            <NewsItem
              heading={n.title}
              date={n.date}
              content={n.text}
              url={n.news_url}
              sentiment={n.sentiment}
              key={n._id}
              imageUrl={n.image_url}
            />
          ))
        : specificNews &&
          specificNews.length > 0 &&
          specificNews.map((n, index) => (
            <NewsItem
              heading={n.title}
              date={n.date}
              content={n.text}
              url={n.news_url}
              sentiment={n.sentiment}
              key={n._id}
              imageUrl={n.image_url}
            />
          ))}
    </div>
  );
};

export default NewsContainer;
